const errorCodes = {
  EMAIL_EXISTS: '9102',
};

export default errorCodes;



// WEBPACK FOOTER //
// ./src/components/common/error-codes.js